export type LogoProps = {
  withText?: boolean
  set?: boolean
}

const Logo = ({ withText = false, set = false }: LogoProps) => {
  return set ? (
    <svg width="384" height="169" viewBox="0 0 384 169" fill="none">
      <g clipPath="url(#clip0_437_28503)">
        <path
          d="M372.857 16.3889L347.134 60.9392L304.273 135.187L287.122 164.885"
          fill="currentColor"
        />
        <path
          d="M367.067 13.0564L281.335 161.548L292.907 168.229L378.639 19.7373L367.067 13.0564Z"
          fill="currentColor"
        />
        <path
          d="M200.327 75.1688L230.025 92.3198L304.273 135.187L333.971 152.332"
          fill="currentColor"
        />
        <path
          d="M203.668 69.3845L196.987 80.9561L330.631 158.116L337.312 146.544L203.668 69.3845Z"
          fill="currentColor"
        />
        <path
          d="M183.176 104.873L230.025 92.3198L347.134 60.9392L382.271 51.5256"
          fill="currentColor"
        />
        <path
          d="M380.539 45.0607L181.445 98.4077L184.904 111.314L383.997 57.9671L380.539 45.0607Z"
          fill="currentColor"
        />
        <path
          d="M12.2356 78.5009V99.5141C12.2356 101.548 13.2359 102.495 16.1772 102.495H19.1848V107.921C17.7141 108.053 16.3097 108.126 15.104 108.126C8.89018 108.126 5.54477 105.96 5.54477 100.13V78.5075H0V72.9495H5.55139V62.9199H12.2356V72.9495H19.1848V78.5075H12.2356V78.5009Z"
          fill="currentColor"
        />
        <path
          d="M54.2419 92.6709H28.2405C28.8433 99.7857 32.5862 103.045 38.131 103.045C42.6092 103.045 45.4842 100.74 46.6899 97.2153H53.4403C51.7047 103.992 46.2858 108.742 37.9985 108.742C28.2405 108.742 21.4834 101.694 21.4834 90.4384C21.4834 79.1832 28.0351 72.1347 37.8593 72.1347C48.2864 72.1347 54.2353 80.2034 54.2353 90.71V92.6775L54.2419 92.6709ZM28.3001 87.3116H47.3524C46.7495 81.8861 43.477 77.8186 37.8593 77.8186C32.8445 77.8186 29.1679 80.8659 28.3001 87.3116Z"
          fill="currentColor"
        />
        <path
          d="M58.3162 90.4318C58.3162 79.2495 64.8679 72.1281 74.7584 72.1281C83.3173 72.1281 89.0674 77.2091 90.134 85.1453H83.3173C82.3832 80.263 78.8391 78.0305 74.7584 78.0305C69.2798 78.0305 65.2653 81.9655 65.2653 90.4384C65.2653 98.9112 69.4123 102.846 74.7584 102.846C78.9053 102.846 82.582 100.541 83.3836 95.4598H90.2002C89.1337 103.727 82.9795 108.749 74.7584 108.749C65.0004 108.749 58.3162 101.634 58.3162 90.445V90.4318Z"
          fill="currentColor"
        />
        <path
          d="M124.893 84.4696V107.927H118.209V85.4236C118.209 80.4088 115.599 78.1034 110.922 78.1034C106.841 78.1034 102.23 81.1507 102.23 88.2059V107.934H95.5461V59.6672H102.23V77.7656C104.503 74.5129 108.113 72.1413 112.79 72.1413C120.276 72.1413 124.893 76.4804 124.893 84.4763V84.4696Z"
          fill="currentColor"
        />
        <path
          d="M29.3469 141.083V164.541H22.6627V142.037C22.6627 137.022 20.0526 134.717 15.3756 134.717C11.2949 134.717 6.68419 137.764 6.68419 144.82V164.548H0V129.57H6.41921V134.79C8.69144 131.332 12.3681 128.755 17.2504 128.755C24.7362 128.755 29.3535 133.094 29.3535 141.09L29.3469 141.083Z"
          fill="currentColor"
        />
        <path
          d="M67.7827 149.285H41.7812C42.3841 156.399 46.127 159.659 51.6717 159.659C56.1499 159.659 59.025 157.353 60.2307 153.829H66.9811C65.2455 160.606 59.8266 165.356 51.5392 165.356C41.7812 165.356 35.0242 158.307 35.0242 147.052C35.0242 135.797 41.5759 128.748 51.4001 128.748C61.8272 128.748 67.7761 136.817 67.7761 147.324V149.291L67.7827 149.285ZM41.8475 143.932H60.8998C60.2969 138.506 57.0244 134.439 51.4067 134.439C46.3919 134.439 42.7153 137.486 41.8475 143.932Z"
          fill="currentColor"
        />
        <path
          d="M121.687 129.557L110.253 164.534H103.231L98.4877 149.145C97.282 145.482 96.2154 141.62 95.2151 137.89C94.2148 141.62 93.1416 145.482 92.0088 149.145L87.3319 164.534H80.2436L68.8096 129.557H76.0304L80.4423 144.131C81.7142 148.331 82.9133 152.471 84.0527 156.605C85.1193 152.405 86.2587 148.337 87.5306 144.131L91.9426 129.557H98.6268L102.972 144.131C104.178 148.264 105.377 152.398 106.517 156.538C107.649 152.405 108.855 148.271 110.061 144.131L114.539 129.557H121.694H121.687Z"
          fill="currentColor"
        />
        <path
          d="M122.985 153.418H129.669C130.206 158.301 132.544 160.063 138.162 160.063C143.78 160.063 145.78 158.301 145.78 155.18C145.78 152.398 144.111 151.047 138.427 150.026L134.883 149.351C127.463 147.993 123.919 144.608 123.919 138.91C123.919 132.743 128.735 128.742 137.221 128.742C147.046 128.742 151.597 133.081 151.795 140.467H145.31C145.045 135.452 142.104 134.028 137.221 134.028C132.876 134.028 130.537 135.79 130.537 138.705C130.537 141.62 132.876 142.839 136.956 143.654L140.567 144.263C148.993 145.893 152.531 148.874 152.531 154.703C152.531 161.553 147.118 165.415 138.089 165.415C129.06 165.415 123.449 161.752 122.979 153.418H122.985Z"
          fill="currentColor"
        />
        <path
          d="M12.2356 10.7382V13.9246H19.4564V19.4826H12.2356V48.9023H5.55139V19.4826H0V13.9246H5.55139V10.7382C5.55139 4.57068 8.42646 0.436951 15.9122 0.436951C17.0517 0.436951 18.7873 0.569442 19.7214 0.642312V6.13408H16.7138C13.7062 6.13408 12.2356 7.76373 12.2356 10.7448V10.7382Z"
          fill="currentColor"
        />
        <path
          d="M57.5013 37.7863H64.1854C64.722 42.6686 67.0605 44.4307 72.6782 44.4307C78.2958 44.4307 80.2964 42.6686 80.2964 39.5484C80.2964 36.7661 78.627 35.4147 72.9431 34.3945L69.399 33.7188C61.9795 32.3608 58.4353 28.9756 58.4353 23.2785C58.4353 17.111 63.2514 13.1097 71.7375 13.1097C81.5617 13.1097 86.1128 17.4488 86.3115 24.8352H79.8261C79.5611 19.8204 76.6198 18.3962 71.7375 18.3962C67.3917 18.3962 65.0533 20.1583 65.0533 23.0731C65.0533 25.9879 67.3917 27.2068 71.4725 28.0217L75.0829 28.6311C83.5093 30.2608 87.0468 33.2418 87.0468 39.0714C87.0468 45.9213 81.6346 49.7834 72.6053 49.7834C63.576 49.7834 57.965 46.12 57.4946 37.7863H57.5013Z"
          fill="currentColor"
        />
        <path
          d="M121.859 25.4514V48.909H115.175V26.4053C115.175 21.3905 112.565 19.0851 107.888 19.0851C103.807 19.0851 99.1964 22.1325 99.1964 29.1876V48.9156H92.5122V0.642334H99.1964V18.7407C101.469 15.488 105.079 13.1164 109.756 13.1164C117.242 13.1164 121.852 17.4555 121.852 25.4514H121.859Z"
          fill="currentColor"
        />
        <path
          d="M129.153 1.72211H135.969V8.97602H129.153V1.72211ZM129.225 13.9246H135.91V48.9023H129.225V13.9246Z"
          fill="currentColor"
        />
        <path
          d="M141.521 31.4134C141.521 20.2312 148.543 13.1097 158.632 13.1097C168.721 13.1097 175.677 20.2245 175.677 31.4134C175.677 42.6023 168.655 49.7171 158.632 49.7171C148.609 49.7171 141.521 42.6023 141.521 31.4134ZM168.728 31.4134C168.728 23.4176 164.72 18.9394 158.632 18.9394C152.544 18.9394 148.47 23.411 148.47 31.4134C148.47 39.4159 152.484 43.8875 158.632 43.8875C164.78 43.8875 168.728 39.4159 168.728 31.4134Z"
          fill="currentColor"
        />
        <path
          d="M210.794 25.4513V48.9089H204.11V26.4053C204.11 21.3905 201.5 19.0851 196.823 19.0851C192.742 19.0851 188.131 22.1324 188.131 29.1876V48.9156H181.447V13.9246H187.866V19.1447C190.138 15.6867 193.815 13.1097 198.697 13.1097C206.183 13.1097 210.794 17.4488 210.794 25.4447V25.4513Z"
          fill="currentColor"
        />
        <path
          d="M38.0846 13.1164C27.7238 13.1164 23.8484 17.7933 23.4443 24.8419H30.0622C30.3935 20.0987 32.6723 18.5353 38.0846 18.5353C43.4969 18.5353 45.1729 20.2974 45.1729 23.5501C45.1729 26.3987 43.371 27.5513 40.0256 27.9554L34.9445 28.4987C25.319 29.446 21.9736 33.7188 21.9736 39.3431C21.9736 46.0538 26.8559 49.7172 34.2755 49.7172C39.2903 49.7172 43.1656 47.8159 45.5041 44.1591V48.9023H51.718V23.4176C51.718 17.3164 47.9751 13.1164 38.078 13.1164H38.0846ZM45.1663 35.0769C45.1663 41.6551 40.1515 44.4308 35.2692 44.4308C30.9234 44.4308 28.8499 42.3308 28.8499 39.1443C28.8499 35.9579 30.5193 34.0633 36.0707 33.381L40.8868 32.8377C42.7615 32.6324 44.166 32.2283 45.1663 31.4135V35.0769Z"
          fill="currentColor"
        />
      </g>
      <defs>
        <clipPath id="clip0_437_28503">
          <rect
            width="384"
            height="167.787"
            fill="white"
            transform="translate(0 0.436951)"
          />
        </clipPath>
      </defs>
    </svg>
  ) : withText ? (
    <svg width="220" height="29" viewBox="0 0 220 29" fill="none">
      <g clipPath="url(#clip0_37_10949)">
        <path
          d="M49.6315 12.2503V13.3077H52.0266V15.1525H49.6315V24.914H47.4132V15.1525H45.5723V13.3077H47.4132V12.2503C47.4132 10.2036 48.367 8.83179 50.8513 8.83179C51.2287 8.83179 51.8052 8.87634 52.1157 8.89862V10.7199H51.1173C50.1189 10.7199 49.6315 11.2597 49.6315 12.249V12.2503Z"
          fill="currentColor"
        />
        <path
          d="M64.3719 21.2243H66.5902C66.7671 22.8438 67.5441 23.4281 69.4073 23.4281C71.2705 23.4281 71.9361 22.8438 71.9361 21.8087C71.9361 20.8862 71.3819 20.4368 69.4964 20.0988L68.3211 19.8734C65.8591 19.424 64.6838 18.2985 64.6838 16.4091C64.6838 14.3624 66.281 13.0351 69.0981 13.0351C72.358 13.0351 73.8674 14.4751 73.9329 16.9266H71.7815C71.6924 15.2626 70.7175 14.7896 69.0981 14.7896C67.6568 14.7896 66.8798 15.3739 66.8798 16.3409C66.8798 17.3079 67.6555 17.7128 69.009 17.9827L70.2065 18.1845C73.0013 18.7243 74.1766 19.7135 74.1766 21.6488C74.1766 23.9208 72.3803 25.2022 69.385 25.2022C66.3897 25.2022 64.5279 23.9876 64.3719 21.2217V21.2243Z"
          fill="currentColor"
        />
        <path
          d="M85.724 17.131V24.9127H83.5057V17.4455C83.5057 15.7814 82.6409 15.0162 81.0883 15.0162C79.7348 15.0162 78.2044 16.0278 78.2044 18.3679V24.9127H75.9861V8.89862H78.2044V14.9036C78.9591 13.8239 80.1567 13.0364 81.7093 13.0364C84.1936 13.0364 85.724 14.4764 85.724 17.1297V17.131Z"
          fill="currentColor"
        />
        <path
          d="M88.1454 9.25894H90.4082V11.6659H88.1454V9.25894ZM88.1677 13.3077H90.3859V24.914H88.1677V13.3077Z"
          fill="currentColor"
        />
        <path
          d="M92.2478 19.1108C92.2478 15.4002 94.5775 13.0377 97.9265 13.0377C101.276 13.0377 103.583 15.3988 103.583 19.1108C103.583 22.8228 101.253 25.1839 97.9265 25.1839C94.5997 25.1839 92.2478 22.8228 92.2478 19.1108ZM101.276 19.1108C101.276 16.4562 99.9443 14.9717 97.9265 14.9717C95.9087 14.9717 94.5552 16.4562 94.5552 19.1108C94.5552 21.7654 95.8864 23.2486 97.9265 23.2486C99.9666 23.2486 101.276 21.7641 101.276 19.1108Z"
          fill="currentColor"
        />
        <path
          d="M115.234 17.131V24.9127H113.016V17.4455C113.016 15.7814 112.151 15.0162 110.598 15.0162C109.245 15.0162 107.714 16.0278 107.714 18.3679V24.9127H105.496V13.3063H107.625V15.0385C108.38 13.892 109.6 13.0364 111.218 13.0364C113.702 13.0364 115.232 14.4764 115.232 17.1297L115.234 17.131Z"
          fill="currentColor"
        />
        <path
          d="M124.741 15.1525V22.1244C124.741 22.7992 125.074 23.1137 126.05 23.1137H127.048V24.9127C126.561 24.9572 126.095 24.9795 125.695 24.9795C123.633 24.9795 122.523 24.2602 122.523 22.3249V15.1499H120.682V13.305H122.523V9.97697H124.741V13.305H127.048V15.1499H124.741V15.1525Z"
          fill="currentColor"
        />
        <path
          d="M138.96 19.8524H130.332C130.531 22.2135 131.773 23.2932 133.614 23.2932C135.1 23.2932 136.054 22.528 136.454 21.3592H138.694C138.118 23.609 136.321 25.1826 133.571 25.1826C130.332 25.1826 128.093 22.8438 128.093 19.1095C128.093 15.3753 130.266 13.0364 133.526 13.0364C136.987 13.0364 138.961 15.7133 138.961 19.1986V19.8511L138.96 19.8524ZM130.354 18.0757H136.676C136.477 16.2767 135.39 14.9271 133.526 14.9271C131.862 14.9271 130.642 15.9387 130.354 18.0757Z"
          fill="currentColor"
        />
        <path
          d="M140.312 19.1108C140.312 15.4002 142.486 13.0377 145.768 13.0377C148.608 13.0377 150.515 14.7241 150.87 17.3564H148.608C148.297 15.7369 147.122 14.9953 145.768 14.9953C143.95 14.9953 142.618 16.3003 142.618 19.1108C142.618 21.9213 143.994 23.2264 145.768 23.2264C147.144 23.2264 148.364 22.4612 148.63 20.7749H150.893C150.538 23.5185 148.497 25.1826 145.768 25.1826C142.529 25.1826 140.312 22.8215 140.312 19.1095V19.1108Z"
          fill="currentColor"
        />
        <path
          d="M162.403 17.131V24.9127H160.185V17.4455C160.185 15.7814 159.32 15.0162 157.768 15.0162C156.414 15.0162 154.884 16.0278 154.884 18.3679V24.9127H152.665V8.89862H154.884V14.9036C155.638 13.8239 156.836 13.0364 158.389 13.0364C160.873 13.0364 162.403 14.4764 162.403 17.1297V17.131Z"
          fill="currentColor"
        />
        <path
          d="M179.128 17.131V24.9127H176.909V17.4455C176.909 15.7814 176.044 15.0162 174.492 15.0162C173.138 15.0162 171.608 16.0278 171.608 18.3679V24.9127H169.39V13.3063H171.519V15.0385C172.272 13.892 173.493 13.0364 175.112 13.0364C177.596 13.0364 179.126 14.4764 179.126 17.1297L179.128 17.131Z"
          fill="currentColor"
        />
        <path
          d="M191.88 19.8524H183.252C183.451 22.2135 184.694 23.2932 186.534 23.2932C188.02 23.2932 188.974 22.528 189.374 21.3592H191.614C191.038 23.609 189.241 25.1826 186.491 25.1826C183.252 25.1826 181.013 22.8438 181.013 19.1095C181.013 15.3753 183.187 13.0364 186.447 13.0364C189.907 13.0364 191.882 15.7133 191.882 19.1986V19.8511L191.88 19.8524ZM183.275 18.0757H189.597C189.397 16.2767 188.31 14.9271 186.447 14.9271C184.783 14.9271 183.563 15.9387 183.275 18.0757Z"
          fill="currentColor"
        />
        <path
          d="M209.765 13.3077L205.972 24.914H203.643L202.068 19.8079C201.668 18.5933 201.314 17.3118 200.981 16.0736C200.649 17.3105 200.294 18.5933 199.918 19.8079L198.365 24.914H196.014L192.221 13.3077H194.616L196.08 18.1438C196.502 19.538 196.9 20.9098 197.277 22.283C197.632 20.8889 198.01 19.5393 198.43 18.1438L199.894 13.3077H202.112L203.553 18.1438C203.953 19.5157 204.351 20.8875 204.729 22.2594C205.106 20.8875 205.504 19.5157 205.904 18.1438L207.39 13.3077H209.763H209.765Z"
          fill="currentColor"
        />
        <path
          d="M210.195 21.2243H212.413C212.59 22.8438 213.367 23.4281 215.231 23.4281C217.094 23.4281 217.759 22.8438 217.759 21.8087C217.759 20.8862 217.205 20.4368 215.32 20.0988L214.144 19.8734C211.682 19.424 210.507 18.2985 210.507 16.4091C210.507 14.3624 212.104 13.0351 214.921 13.0351C218.181 13.0351 219.691 14.4751 219.756 16.9266H217.605C217.516 15.2626 216.539 14.7896 214.921 14.7896C213.48 14.7896 212.703 15.3739 212.703 16.3409C212.703 17.3079 213.479 17.7128 214.832 17.9827L216.03 18.1845C218.825 18.7243 220 19.7135 220 21.6488C220 23.9208 218.204 25.2022 215.208 25.2022C212.213 25.2022 210.351 23.9876 210.195 21.2217V21.2243Z"
          fill="currentColor"
        />
        <path
          d="M58.2084 13.0377C54.7703 13.0377 53.4836 14.5891 53.3513 16.9292H55.5473C55.6587 15.3543 56.4121 14.838 58.2084 14.838C60.0048 14.838 60.5591 15.4224 60.5591 16.5021C60.5591 17.4468 59.9603 17.8294 58.8505 17.9643L57.1642 18.1438C53.9697 18.4583 52.8613 19.876 52.8613 21.7431C52.8613 23.9693 54.4807 25.1839 56.9427 25.1839C58.6068 25.1839 59.8921 24.5537 60.6691 23.339V24.914H62.7315V16.4575C62.7315 14.4332 61.4893 13.0391 58.2071 13.0391L58.2084 13.0377ZM60.5604 20.3254C60.5604 22.507 58.8963 23.4295 57.2782 23.4295C55.8369 23.4295 55.149 22.7324 55.149 21.675C55.149 20.6176 55.7032 19.9887 57.5441 19.7633L59.1413 19.5838C59.7624 19.517 60.2289 19.382 60.5617 19.1121V20.3267L60.5604 20.3254Z"
          fill="currentColor"
        />
        <path
          d="M28.4448 8.95363L20.2399 23.1649L22.2257 24.3114L30.4305 10.1001L28.4448 8.95363Z"
          fill="currentColor"
        />
        <path
          d="M6.72403 14.4256L-0.000198364 16.2274L0.593264 18.4422L7.3175 16.6404L6.72403 14.4256Z"
          fill="currentColor"
        />
        <path
          d="M35.8638 6.61636L29.1396 8.41812L29.7331 10.6329L36.4573 8.8312L35.8638 6.61636Z"
          fill="currentColor"
        />
        <path
          d="M20.2392 23.1653L17.7779 27.4284L19.7637 28.5749L22.225 24.3117L20.2392 23.1653Z"
          fill="currentColor"
        />
        <path
          d="M21.8057 22.7444L20.6592 24.7301L24.9224 27.1914L26.0689 25.2057L21.8057 22.7444Z"
          fill="currentColor"
        />
        <path
          d="M3.33122 12.0783L2.18474 14.064L6.44789 16.5254L7.59437 14.5396L3.33122 12.0783Z"
          fill="currentColor"
        />
        <path
          d="M33.3668 0.426387L28.4441 8.95269L30.4299 10.0992L35.3526 1.57287L33.3668 0.426387Z"
          fill="currentColor"
        />
        <path
          d="M7.59474 14.539L6.44826 16.5247L20.6595 24.7296L21.806 22.7438L7.59474 14.539Z"
          fill="currentColor"
        />
        <path
          d="M29.1395 8.41943L6.72414 14.4256L7.3176 16.6404L29.733 10.6343L29.1395 8.41943Z"
          fill="currentColor"
        />
      </g>
      <defs>
        <clipPath id="clip0_37_10949">
          <rect
            width="220"
            height="28.1471"
            fill="white"
            transform="translate(-6.10352e-05 0.426445)"
          />
        </clipPath>
      </defs>
    </svg>
  ) : (
    <svg width="37" height="29" viewBox="0 0 37 29" fill="none">
      <path
        d="M28.4448 8.95363L20.2399 23.1649L22.2257 24.3114L30.4305 10.1001L28.4448 8.95363Z"
        fill="currentColor"
      />
      <path
        d="M6.72403 14.4256L-0.000198364 16.2274L0.593264 18.4422L7.3175 16.6404L6.72403 14.4256Z"
        fill="currentColor"
      />
      <path
        d="M35.8638 6.61636L29.1396 8.41812L29.7331 10.6329L36.4573 8.8312L35.8638 6.61636Z"
        fill="currentColor"
      />
      <path
        d="M20.2392 23.1653L17.7779 27.4284L19.7637 28.5749L22.225 24.3117L20.2392 23.1653Z"
        fill="currentColor"
      />
      <path
        d="M21.8057 22.7444L20.6592 24.7301L24.9224 27.1914L26.0689 25.2057L21.8057 22.7444Z"
        fill="currentColor"
      />
      <path
        d="M3.33122 12.0783L2.18474 14.064L6.44789 16.5254L7.59437 14.5396L3.33122 12.0783Z"
        fill="currentColor"
      />
      <path
        d="M33.3668 0.426387L28.4441 8.95269L30.4299 10.0992L35.3526 1.57287L33.3668 0.426387Z"
        fill="currentColor"
      />
      <path
        d="M7.59474 14.539L6.44826 16.5247L20.6595 24.7296L21.806 22.7438L7.59474 14.539Z"
        fill="currentColor"
      />
      <path
        d="M29.1395 8.41943L6.72414 14.4256L7.3176 16.6404L29.733 10.6343L29.1395 8.41943Z"
        fill="currentColor"
      />
    </svg>
  )
}

export default Logo
